const Color = {
   primary: "#16314d",
   secondary: "#d6c498",
   textColor: "#999",
};

export default Color;
